type DesignRow = {
  name?: string | null;
  qty?: number | string | null;
  meta_json?: unknown;
  metaJson?: unknown;
};

function stableStringify(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(stableStringify).join(',')}]`;
  if (value && typeof value === 'object') {
    const record = value as Record<string, unknown>;
    return `{${Object.keys(record)
      .sort()
      .filter((key) => record[key] !== undefined)
      .map((key) => `${JSON.stringify(key)}:${stableStringify(record[key])}`)
      .join(',')}}`;
  }
  return JSON.stringify(value ?? null);
}

export function designFingerprint(row: DesignRow): string {
  return stableStringify({
    name: String(row.name || '').trim(),
    qty: Number(row.qty || 1) || 1,
    meta: row.meta_json ?? row.metaJson ?? null,
  });
}

/** True when the sheet and the version hold the same designs, ignoring order. */
export function sheetMatchesVersion(sheet: DesignRow[], versionDesigns: DesignRow[]): boolean {
  if (sheet.length !== versionDesigns.length) return false;
  const a = sheet.map(designFingerprint).sort();
  const b = versionDesigns.map(designFingerprint).sort();
  return a.every((fingerprint, idx) => fingerprint === b[idx]);
}
